module.exports = __webpack_public_path__ + "img/MU.475af446.svg";